import React, { useMemo } from "react";
import { useFragment, graphql } from "react-relay";

import { Pressable } from "react-native";
import {
  Box,
  useBoxStyle,
  EmployeeAvatar,
  UserAvatar,
  GuestAvatar,
} from "arkh";
import { TeamHeaderProfileButton_storeUser$key } from "./__generated__/TeamHeaderProfileButton_storeUser.graphql";
import { TeamHeaderProfileButton_employee$key } from "./__generated__/TeamHeaderProfileButton_employee.graphql";

export function TeamHeaderProfileButton(props: {
  user: TeamHeaderProfileButton_storeUser$key | null;
  employee: TeamHeaderProfileButton_employee$key | null;
  onPress(): void;
  compact?: boolean;
  badge?: React.ReactNode;
}) {
  const employee = useFragment(
    graphql`
      fragment TeamHeaderProfileButton_employee on Employee {
        ...Avatar_employee
      }
    `,
    props.employee
  );

  const user = useFragment(
    graphql`
      fragment TeamHeaderProfileButton_storeUser on StoreUser {
        user {
          ...Avatar_user
        }
      }
    `,
    props.user
  );
  const pressableStyle = useBoxStyle({
    spaceRight: "small",
    spaceLeft: props.compact ? "small" : "medium",
  });

  const avatar = useMemo(() => {
    if (employee) {
      return <EmployeeAvatar employee={employee} size="medium" disableBorder />;
    }
    if (user?.user) {
      return <UserAvatar user={user.user} size="medium" disableBorder />;
    }
    return <GuestAvatar size="medium" disableBorder />;
  }, [employee, user?.user]);

  return (
    <Pressable
      onPress={props.onPress}
      style={[pressableStyle, { height: "100%", justifyContent: "center" }]}
    >
      {({ pressed }) => (
        <Box
          style={{
            flexDirection: "row",
            alignItems: "center",
            opacity: pressed ? 0.7 : 1,
          }}
        >
          {avatar}
          {props.badge}
        </Box>
      )}
    </Pressable>
  );
}
